module.exports = __webpack_public_path__ + "media/usecase_enterprise_03.f8986877.mp4";